export default {
  banner:
    'You’ll need to start your application again on our renewed platform.\nPlease note. You may need to log in again.\nQuestions? Feel free to schedule a consultation.',
  title: 'Completing your application on this platform is no longer possible.',
  cta: 'Start over',
  schedule: 'Schedule a call'
};
